import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const filter = {
	CreatedFrom: null as Date | null,
	CreatedTo: null as Date | null,
	SaleAbcFms: null as any | null,
	OrganizationId: [1] as number [],
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {}, 		
	filter,
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		filter: {

		},
		mode: null,
		afterRowSelection: () => { },
	},
});
